function addFavicon(sourceUri: string) {
  var head = document.head;
  var link = document.createElement('link');

  link.type = 'image/png';
  link.rel = 'icon';
  link.setAttribute('sizes', '32x32');
  link.href = sourceUri;

  head.appendChild(link);
}

function addCss(sourceUri: string) {
  var head = document.head;
  var link = document.createElement('link');

  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = sourceUri;

  head.appendChild(link);
}

var hostname = window.location.host;

///// Icomoon

// check if we are on production
if (hostname.match('dealer.automotivemastermind.com')) {
  // add Icomoon set, production build
  addCss('https://cdn.icomoon.io/108957/automotiveMastermindUI/style.css?my1o7p');
}
// in other cases we get staging or development
else {
  // add Icomoon set, staging build
  addCss('https://i.icomoon.io/public/c01f99929d/automotiveMastermindUI/style.css');
}

///// Favicons

// check if we are in lightspeed
if (hostname.includes('lightspeed')) {
  addFavicon('https://static.findmyupgrade.com/favicons/env/favicon-ls-32x32.png');
}
// check if we are in localhost
else if (hostname.includes('localhost')) {
  addFavicon('https://static.findmyupgrade.com/favicons/env/favicon-local-32x32.png');
}
// in other cases we get staging or development
else if (hostname.includes('dev') || hostname.includes('stg')) {
  addFavicon('https://static.findmyupgrade.com/favicons/env/favicon-dev-32x32.png');
}
